import React, { useState, useEffect } from "react";
import GHGHero from "./GHGHero";
import Footer from "../../CommonComponents/Footer";
import GHGDetails from "./GHGDetails";

// import List from './List';

const GHGMain = () => {
  const [showLoader, setShowLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoader(false);
    }, 2000); // 2 seconds

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/* {showLoader ? (
        <div className="h-screen flex justify-center items-center">
          <div className="pageLoader"></div>
        </div>
      ) : ( */}
        <div className="bg-white">
          <GHGHero />      
         <GHGDetails/>
          <Footer />
        </div>
      {/* )} */}
    </>
  );
};

export default GHGMain;

